import { createFileRoute } from '@tanstack/react-router'
import { CustomersPage } from '~/components/routes/customers/customers-page'
import { customersSearchSchema } from '~/components/routes/customers/customers-search'
import { USERS_SCREEN_PERMISSIONS } from '~/components/routes/users/screens'
import { withRoutePermissions } from '~/utils/rbac'

/** Écran « Clients » (kanban #870) : tuiles, filtres dans l'URL, tableau paginé et trié serveur. */
export const Route = createFileRoute('/_authenticated/users/app')({
  staticData: {
    permission: USERS_SCREEN_PERMISSIONS.app,
  },
  validateSearch: customersSearchSchema,
  component: CustomersPage,
})
withRoutePermissions(Route)
